<template>
<div id="container">
    <div class="container_wrap">
        <keep-alive>
    		<my-knowledge-snb></my-knowledge-snb>
        </keep-alive>
        <router-view></router-view>
    </div>
</div>
</template>
<script>
import axios            from 'axios';
import SDLUtil          from '@/utils/SDLUtil';

import MyKnowledgeSnb   from './MyKnowledgeSnb';

export default {
    name: 'MyKnowledge',
    components: {
    	'my-knowledge-snb' : MyKnowledgeSnb
    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/myKnowledge/MyKnowledge.vue